/**
 * @generated SignedSource<<09721642ff32bd6c98c9edf80559e598>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type addAIStagingRulePanel_AIStagingRulesListQuery$variables = Record<PropertyKey, never>;
export type addAIStagingRulePanel_AIStagingRulesListQuery$data = {
  readonly aiProductStagingRules: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
    readonly ruleID: number;
  }>;
};
export type addAIStagingRulePanel_AIStagingRulesListQuery = {
  response: addAIStagingRulePanel_AIStagingRulesListQuery$data;
  variables: addAIStagingRulePanel_AIStagingRulesListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AIProductStagingRuleInfoOutput",
    "kind": "LinkedField",
    "name": "aiProductStagingRules",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ruleID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "addAIStagingRulePanel_AIStagingRulesListQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "addAIStagingRulePanel_AIStagingRulesListQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "cacheID": "3cc3591c19d3cac84c71c30eb9329036",
    "id": null,
    "metadata": {},
    "name": "addAIStagingRulePanel_AIStagingRulesListQuery",
    "operationKind": "query",
    "text": "query addAIStagingRulePanel_AIStagingRulesListQuery {\n  aiProductStagingRules {\n    id\n    ruleID\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "dbde91f5d33b3d72370c46cc4ddf06ea";

export default node;
